<template>
  <div class="content">
    <div class="build-CURD">
      <div class="build-bar">
        <el-input placeholder="搜索设备名称" v-model="tableDataName" style="margin-left:30px"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
        <el-button type="primary"  @click="addRow()" style="margin-left:70%">绑定水表</el-button>
      </div>
      <div class="build-table">
        <el-table :data="tableDataEnd" border height="100%" style="width:2470px;margin-top:8px;">
          <template slot="empty">
              <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号" width="100">
              <template slot-scope="scope">
                <span>{{scope.$index+1}}</span>
              </template>
          </el-table-column>
          <el-table-column label="设备名称">
              <template slot-scope="scope">
                <span>{{ scope.row.name}}</span>
              </template>
          </el-table-column>
          <el-table-column label="设备序列号">
              <template slot-scope="scope">
                <span>{{ scope.row.imei}}</span>
              </template>
          </el-table-column>
          <el-table-column label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type=='1'">水表</span>
                <span v-else-if="scope.row.type=='2'">电表</span>
                <span v-else></span>
              </template>
          </el-table-column>
          <el-table-column label="所属项目">
              <template slot-scope="scope">
              <span>{{ scope.row.groupName }}</span>
              </template>
          </el-table-column>
          <el-table-column label="时间">
              <template slot-scope="scope">
              <span>{{ scope.row.createDate }}</span>
              </template>
          </el-table-column>
          <el-table-column label="操作">
              <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
          </el-table-column>
        </el-table>
        <!-- 表单列表 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination>
      </div>
    </div>
    <!-- 新增窗口 -->
    <el-dialog
        :title="dialogTitle"
        :visible.sync="addFormVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        class="add-form"
        width="30%"
    >
        <el-form
        :model="addForm"
        ref="addForm"
        label-width="120px"
        :label-position="labelPosition"
        :rules="rules"
        >
          <el-form-item label="设备名称：" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入名称" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="设备序列号：" prop="imei">
              <el-input v-model="addForm.imei" placeholder="请输入序列号" autocomplete="off">天门湖项目</el-input>
          </el-form-item>
          <!-- <el-form-item label="类型：" prop="type">
              <el-select v-model="addForm.type">
                <el-option label="水表" value="1"></el-option>
                <el-option label="电表" value="2"></el-option>
              </el-select>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base.js'
export default {
  data() {
    return {
      search:{
        type:'',
        imei:''
      },
      inOut: '1',
      status: '3',
      groupId: '',
      searchDate: '',
      tableDataName: '',
      addForm: {   // 添加设备表单数组
        name:'',
        imei:'',
        type:'1',
        groupId:'',
        createBy:''
      },
      dialogTitle:'',//弹出框标题
      labelPosition: 'right', // 添加设备弹出框position属性
      addFormVisible: false, // 弹出框是否显示
      tableDataEnd:[],// 考勤机表单数据
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
      dataText: '数据加载中...',
      rules: {
        name: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        imei: [
          { required: true, message: '请输入设备序列号', trigger: 'blur' }
        ],
      },

    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    this.addForm.groupId = this.groupId
    this.getData()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getData()
    },
    // 监控当前页码
    currentChangePage() {
      this.getData()
    },
    doFilter(){
      this.currentPage = 1
      this.getData()
    },
    //获取数据
    getData() {
      var that = this
      myHttp.selectWaterElectricityListPage({
        type:'1',
        pageNum:this.currentPage,
        pageSize:this.pageSize,
        groupId:this.groupId,
        imei:this.search.imei
      }).then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.PageInfo.list||[]
            for(var i=0;i<list.length;i++){
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.PageInfo.total||0
            if(list.length==0){
              that.dataText = '暂无数据'
            }
          }else{
            that.dataText = '暂无数据'
          }
      },function() {
        that.dataText = '暂无数据'
      })
    },

    /**
     * 新增设备
     */
    addRow() {
      this.dialogTitle = '考勤机绑定'
      this.addFormVisible = true
      this.addForm.name = ''
      this.addForm.imei = ''
      this.addForm.type = '1'
      this.addForm.id = ''
      this.addForm.createBy = util.session.get('user').id
      
    },
    // 编辑数据
    handleEdit(index, row) {
      this.dialogTitle = '编辑设备信息'
      this.addFormVisible = true
      this.addForm.name = row.name
      this.addForm.imei = row.imei
      this.addForm.type = row.type
      this.addForm.id = row.id
      this.addForm.updateBy = util.session.get('user').id
    },
    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm.id == '') {
            //添加
            myHttp.postWaterElectricity(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.currentPage = 1
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            //修改 
            myHttp.updateWaterElectricity(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          }
        }
      })
    },
    cancel() {
      this.addFormVisible = false
    },

    // 删除数据 111
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp
          .deleteWaterElectricity({
            id: row.id,
            updateBy:util.session.get('user').id
          })
          .then(function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },
  }
}
</script>

<style scoped>
.build-bar span {
  margin-left: 30px !important;
  /* margin-right: 40px */
}
* {
  box-sizing: border-box;
}
.content {
  height: 100%;
  background: #fff;
  margin-top: 20px;
}
.build-CURD {
  width: 100%;
  height: 100%;
  position: relative;
}
.build-table {
  height: calc(100% - 160px);
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
.build-bar {
  padding: 10px 20px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bulid-foot {
  text-align: right;
  margin-right: 50px;
}

.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}

.box-card {
  width: 480px;
}
</style>
